/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Six_PlusInputs */

const cs_enum_six_plus = /** @type {(inputs: Enum_Six_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6+`)
};

const en_enum_six_plus = /** @type {(inputs: Enum_Six_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6+`)
};

/**
* | output |
* | --- |
* | "6+" |
*
* @param {Enum_Six_PlusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_six_plus = /** @type {((inputs?: Enum_Six_PlusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Six_PlusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_six_plus(inputs)
	return cs_enum_six_plus(inputs)
});